const ROLE_EQUIVALENTS = {
  admin: ['admin', 'sp_admin'],
  sp_admin: ['sp_admin', 'admin'],
  manager: ['manager', 'sp_manager'],
  sp_manager: ['sp_manager', 'manager'],
  sales: ['sales', 'sp_sales'],
  sp_sales: ['sp_sales', 'sales'],
  storekeeper: ['storekeeper', 'sp_storekeeper'],
  sp_storekeeper: ['sp_storekeeper', 'storekeeper'],
  accountant: ['accountant', 'sp_accountant'],
  sp_accountant: ['sp_accountant', 'accountant'],
};

export const expandRoles = (roles = []) => {
  const expanded = new Set();

  for (const role of roles) {
    if (!role) continue;
    expanded.add(role);
    for (const alias of ROLE_EQUIVALENTS[role] || []) {
      expanded.add(alias);
    }
  }

  return [...expanded];
};

export const hasAnyRole = (userRoles = [], allowedRoles = []) => {
  if (!allowedRoles?.length) return true;

  const expandedUserRoles = new Set(expandRoles(userRoles));
  return allowedRoles.some((role) => expandRoles([role]).some((candidate) => expandedUserRoles.has(candidate)));
};

export const getPreferredSystem = (userRoles = []) => {
  const expandedRoles = expandRoles(userRoles);
  const hasSpOnlyRole = expandedRoles.some((role) => role?.startsWith('sp_'));
  const hasCarRole = expandedRoles.some((role) => ['admin', 'manager', 'sales', 'storekeeper', 'accountant'].includes(role));

  if (hasSpOnlyRole && !hasCarRole) {
    return 'spare_parts';
  }

  return 'car_sales';
};

export const getHomePathForRoles = (userRoles = [], preferredSystem) => {
  const system = preferredSystem || getPreferredSystem(userRoles);
  return system === 'spare_parts' ? '/sp/dashboard' : '/dashboard';
};
